module.exports = __webpack_public_path__ + "media/images/area/maps/shikoku-32a1595074f09982fab62cb76860e398.svg";